import React, { useEffect, useState } from 'react'
import { solicitacaoIdState, solicitacaoState } from '../../../atoms';
import { useRecoilValue } from 'recoil';
import { Modal, Tooltip } from 'antd';
import { Button, Row, Table } from '@digital/ui';
import { UploadComponent } from '@app/components/uploadFileNovo';
import { DownloadAnexoSolicitacao, deleteAnexoSolicitacao, getAnexoSolicitacao } from '@app/api/naoPrevistos/anexosSolicitacao';
import { Visibility } from '@app/components/Visibility';
import { EStatusSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { hasPermission } from '@app/helpers/permissions';

const ModalAnexos = () => {
    const solicitacaoId = useRecoilValue(solicitacaoIdState);
    const solicitacao = useRecoilValue(solicitacaoState);
    const [modalOpen, setModalOpen] = useState(false)
    const [anexos, setAnexos] = useState([])

    const getAnexos = () => {
        if (solicitacaoId) {
            getAnexoSolicitacao(solicitacaoId).then((result) => {
                if (result) {
                    setAnexos(result)
                }
            })
        }
    }

    useEffect(() => {
        if (solicitacaoId && modalOpen) {
            getAnexos()
        }
    }, [modalOpen])

    const handleRemoveAnexo = (record: any) => {
        deleteAnexoSolicitacao(record.id).then((result) => {
            if (result && result.valid) {
                getAnexos()
            }
        });
    }

    const handleDownloadAnexo = (record: any) => {
        DownloadAnexoSolicitacao(record.id, record.nome)
    }

    const handleUploadAnexo = (data: any) => {
        getAnexos()
    }

    const columns = () => {
        const collumns = []

        collumns.push({
            title: 'Nome',
            dataIndex: 'nome',
            render(text, record, index) {
                return (
                    <span>{record.nome}</span>
                )
            },
        })

        collumns.push({
            title: 'Ação',
            dataIndex: 'acao',
            key: 'acao',
            width: '5%',
            render: (text, record, index) =>
                <>
                    <Tooltip title="Download">
                        <Button
                            icon="ui-download"
                            onClick={() => handleDownloadAnexo(record)}
                        />
                    </Tooltip>
                    <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}>
                        <Tooltip title="Remover">
                            <Button
                                icon="ui-delete"
                                confirm="Deseja realmente excluir este registro?"
                                okText="Confirmar"
                                onClick={() => handleRemoveAnexo(record)}
                            />
                        </Tooltip>
                    </Visibility>
                </>
        })

        return collumns
    }


    return (
        <>
            <Button
                title='Anexos'
                onClick={() => setModalOpen(true)}
            />

            <Modal
                visible={modalOpen}
                title="Anexos"
                onCancel={() => setModalOpen(false)}
                footer={null}
            >
                <Visibility visible={solicitacao.statusId === EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao ||
                    hasPermission(['NAO_PREVISTO_SOLICITACAO_ANEXO_INCLUIR_ADMINISTRADOR'])}>
                    <Row>
                        <UploadComponent
                            idDoComponente={'anexos'}
                            nomeIdFormulario={'solicitacaoNaoPrevistoId'}
                            id={solicitacaoId || ''}
                            enderecoApi={'/NaoPrevistoAnexoSolicitacao'}
                            retorno={handleUploadAnexo}
                            iconName={'ui-upload'}
                            hasFile={false}
                            label={'Adicionar Anexo'}
                            buttonClass={'mrn-button-upload'}
                            disabled={false}
                            type={'link'}
                        />
                    </Row>
                </Visibility>
                <Row>
                    <Table
                        dataSource={anexos || []}
                        columns={columns()}
                        pagination={false}
                    />
                </Row>
            </Modal>
        </>
    )
}

export default ModalAnexos